<div class="container">
  <mic-breadcrumb id="casing-repair-details-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/casing-CreditRepair"
      label="{{ translationService.translate('CasingCreditRepairText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('CasingCreditRepairDetailsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="casing-credit-details-header">
    <h2 class="page-title casing-credit-details-heading" id="casing-repair-heading">
      {{ translationService.translate('CasingCreditRepairDetailsText') }}
    </h2>
  </div>
  <div class="casing-credit-summary" id="customer-name">
    <div class="casing-credit-summary-text">
      <span class="casing-credit-label">{{ translationService.translate('codeText') }}: </span>
      <span class="casing-credit-value">{{ code }} | </span>
      <span class="casing-credit-label">{{ translationService.translate('descriptionText') }}: </span>
      <span class="casing-credit-value">{{ description }}</span>
    </div>

    <div class="action-bar">
      <!-- Cancel Button -->
      <button id="cancel-button" mat-flat-button class="btn-cancel casing-credit-details-action-button" (click)="navigateBack()">
        <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelText') }}
      </button>

      <!-- Save Button -->
      <button
        id="save-changes"
        type="button"
        mat-flat-button
        color="primary"
        class="btn-primary casing-credit-details-action-button"
        (click)="saveChanges()"
      >
        <mat-icon>save</mat-icon> {{ translationService.translate('saveLinkText') }}
      </button>

      <button mat-flat-button color="primary" class="btn-export casing-credit-details-action-button" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        {{ translationService.translate('exportButtonText') }}
      </button>
    </div>
  </div>

  <mat-card class="casing-credit-details-filter-card">
    <form [formGroup]="filterForm" class="casing-credit-details-form">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          id="repairCodes"
          formControlName="repairCodes"
          [data]="codeList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('SearchByRepairCodeText') }}"
          label="{{ translationService.translate('SearchByRepairCodeText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="repairDescriptions"
          formControlName="repairDescriptions"
          [data]="descriptionList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('SearchByDescriptionText') }}"
          label="{{ translationService.translate('SearchByDescriptionText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="amounts"
          formControlName="amounts"
          [data]="amountList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('SearchByAmountText') }}"
          label="{{ translationService.translate('SearchByAmountText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>
      </div>
      <div class="button-container">
        <button
          id="clear-filters"
          type="button"
          mat-flat-button
          color="accent"
          class="btn-clear clear-filters-button"
          (click)="clearFilters()"
        >
          <mat-icon>refresh</mat-icon> {{ translationService.translate('clearFiltersText') }}
        </button>
      </div>
    </form>
  </mat-card>

  <!-- Loading Overlay -->
  @if (isLoading) {
  <div class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  }

  <div id="finished-product-table" class="cam-table table-container btn-table">
    <div class="table-wrapper">
      <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'amount'">
          <input
            id="AmountInput"
            matInput
            type="text"
            min="0"
            pattern="^\\d{0,3}(\\.\\d{0,2})?$"
            maxlength="6"
            [attr.aria-label]="translationService.translate('SearchByAmountText')"
            [formControl]="getControl(item, 'amount')"
            (keydown)="handleKeydown($event)"
            (input)="restrictTwoDecimalPlaces($event, item)"
            (blur)="onAmountBlur($event, item)"
            placeholder="0.00"
          />
        </ng-container>
      </mic-table>
    </div>
  </div>

  <!-- Unsaved Changes Modal -->
  <ng-template #unsavedConfirmation>{{ translationService.translate('unSaveChangesText') }}</ng-template>
  <mic-modal class="modalC" #unsavedChangesModal></mic-modal>
</div>
